import { takeLatest, put } from 'redux-saga/effects'
import { Types } from '../ducks/admin'
import oikosApi from '../../services/oikos'
import { notifyError } from '../../utils/notify'

function* getActivities() {
  try {
    const res = yield oikosApi.get('/', {
      table: 'setorAtiv',
      action: 'get',
    })
    console.tron.log('res getActivities', res)

    yield put({ type: Types.GET_ACTIVITIES_SUCCEEDED, payload: res.data })
  } catch (err) {
    console.tron.log('GET_ACTIVITIES_FAILED', err)
    notifyError('Não foi possível listar as Atividades.')
    yield put({ type: Types.GET_ACTIVITIES_FAILED, payload: err })
  }
}

function* getDepartments() {
  try {
    const res = yield oikosApi.get('/', {
      table: 'dpto',
      action: 'get',
    })
    console.tron.log('res getDepartments', res)

    yield put({ type: Types.GET_DEPARTMENTS_SUCCEEDED, payload: res.data })
  } catch (err) {
    console.tron.log('GET_DEPARTMENTS_FAILED', err)
    notifyError('Não foi possível listar os Departamentos.')
    yield put({ type: Types.GET_DEPARTMENTS_FAILED, payload: err })
  }
}

function* getSectors() {
  try {
    const res = yield oikosApi.get('/', {
      table: 'setor',
      action: 'get',
    })
    console.tron.log('res getSectors', res)

    yield put({ type: Types.GET_SECTORS_SUCCEEDED, payload: res.data })
  } catch (err) {
    console.tron.log('GET_SECTORS_FAILED', err)
    notifyError('Não foi possível listar os Setores.')
    yield put({ type: Types.GET_SECTORS_FAILED, payload: err })
  }
}

function* getProjects() {
  try {
    const res = yield oikosApi.get('/', {
      table: 'proj',
      action: 'get',
    })
    console.tron.log('res getProjects', res)

    yield put({ type: Types.GET_PROJECTS_SUCCEEDED, payload: res.data })
  } catch (err) {
    console.tron.log('GET_PROJECTS_FAILED', err)
    notifyError('Não foi possível listar os Projetos.')
    yield put({ type: Types.GET_PROJECTS_FAILED, payload: err })
  }
}

function* getDocuments() {
  try {
    const res = yield oikosApi.get('/', {
      table: 'documento',
      action: 'get',
    })
    console.tron.log('res getDocuments', res)

    yield put({ type: Types.GET_DOCUMENTS_SUCCEEDED, payload: res.data })
  } catch (err) {
    console.tron.log('GET_DOCUMENTS_FAILED', err)
    notifyError('Não foi possível listar os Documentos.')
    yield put({ type: Types.GET_DOCUMENTS_FAILED, payload: err })
  }
}

function* getLegalEntities() {
  try {
    const res = yield oikosApi.get('/', {
      table: 'pj',
      action: 'get',
    })
    console.tron.log('res getLegalEntities', res)

    yield put({ type: Types.GET_LEGAL_ENTITIES_SUCCEEDED, payload: res.data })
  } catch (err) {
    console.tron.log('GET_LEGAL_ENTITIES_FAILED', err)
    notifyError('Não foi possível listar as Pessoas Jurídicas.')
    yield put({ type: Types.GET_LEGAL_ENTITIES_FAILED, payload: err })
  }
}

function* getIndividuals() {
  try {
    const res = yield oikosApi.get('/', {
      table: 'pf',
      action: 'get',
    })
    console.tron.log('res getIndividuals', res)

    yield put({ type: Types.GET_INDIVIDUALS_SUCCEEDED, payload: res.data })
  } catch (err) {
    console.tron.log('GET_INDIVIDUALS_FAILED', err)
    notifyError('Não foi possível listar as Pessoas Físicas.')
    yield put({ type: Types.GET_INDIVIDUALS_FAILED, payload: err })
  }
}

function* getServices() {
  try {
    const res = yield oikosApi.get('/', {
      table: 'servico',
      action: 'get',
    })
    console.tron.log('res getServices', res)

    yield put({ type: Types.GET_SERVICES_SUCCEEDED, payload: res.data })
  } catch (err) {
    console.tron.log('GET_SERVICES_FAILED', err)
    notifyError('Não foi possível listar os Serviços.')
    yield put({ type: Types.GET_SERVICES_FAILED, payload: err })
  }
}

export const adminSagas = [
  takeLatest(Types.GET_ACTIVITIES_REQUESTED, getActivities),
  takeLatest(Types.GET_DEPARTMENTS_REQUESTED, getDepartments),
  takeLatest(Types.GET_SECTORS_REQUESTED, getSectors),
  takeLatest(Types.GET_PROJECTS_REQUESTED, getProjects),
  takeLatest(Types.GET_DOCUMENTS_REQUESTED, getDocuments),
  takeLatest(Types.GET_LEGAL_ENTITIES_REQUESTED, getLegalEntities),
  takeLatest(Types.GET_INDIVIDUALS_REQUESTED, getIndividuals),
  takeLatest(Types.GET_SERVICES_REQUESTED, getServices),
]
